import type {
    ExternalListsClientInterface,
    ExternalListsAttributesParams,
    GetExternalListsParams,
    OrgUnitExternalListsContactCountParams,
} from './externalListsClient.types';
import BaseClient, { type ExtendedAxiosRequestConfig } from '../BaseClient';

export default class OrgUnitExternalListsClient extends BaseClient implements ExternalListsClientInterface {
    constructor(private teamId: number, private orgUnitId: number) {
        super();
    }

    getExternalLists(params?: GetExternalListsParams, config?: ExtendedAxiosRequestConfig) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/external-contact-lists`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getExternalListsCount(params?: GetExternalListsParams) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/external-contact-lists/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getExternalListsContactCount(params: OrgUnitExternalListsContactCountParams) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/external-contact-lists/contact-counts`;
        return this.makeCoreApiRequest(url, 'post', params);
    }

    getExternalListsAttributes(params: ExternalListsAttributesParams) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/external-contact-lists/attributes`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }
}
